<template>
  <div v-if="cargando">
    <div class="position-absolute top-50 start-50 translate-middle">
      <fade-loader
        :loading="cargando"
        :color="'#FFA000'"
        :height="'25px'"
        :width="'5px'"
      ></fade-loader>
    </div>
  </div>
  <div v-if="!cargando" class="row">
    <div class="col-sm-12 col-md-12 col-lg-2">
      <navegacion-lateral
        :seleccionA="seleccionadoA" 
        :seleccionB="seleccionadoB" 
        :seleccionC="seleccionadoC" 
        :seleccionD="seleccionadoD" 
        :remarcadoA="subrayadoA"
        :remarcadoB="subrayadoB"
        :remarcadoC="subrayadoC"
        :remarcadoD="subrayadoD">
      </navegacion-lateral>
    </div>
    <div class="col-sm-12 col-md-12 col-lg-10">
      <navegacion-superior></navegacion-superior>
      <div class="position-absolute top-50 start-50 translate-middle">
        <fade-loader
          :loading="cargando"
          :color="'#FFA000'"
          :height="'25px'"
          :width="'5px'"
          v-show="cargando2"
        ></fade-loader>
      </div>
      <lista-operaciones @ToParent="esFiltrado" :operaciones="getItems" v-show="!cargando2 && !estaFiltrado"></lista-operaciones>  
      <lista-operaciones @ToParent="esFiltrado" :operaciones="operaciones" v-show="!cargando2 && estaFiltrado"></lista-operaciones>           
      <div class="d-flex justify-content-center mt-5 mb-5">
        <div class="paginator_buttons m-auto" v-show="!cargando2 && !estaFiltrado">
          <button
              class="paginator__btn"
              v-for="index in totalBotonesArray"
              :key="index"            
              @click="selectPage(index)"
            >
              {{ index + 1 }}
            </button>           
          <br>
        </div> 
     </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import axios from "axios";
import NavegacionSuperior from "@/Aplicaciones/CCD/Componentes/NavegacionSuperior.vue";
import NavegacionLateral from "@/Aplicaciones/CCD/Componentes/NavegacionLateral.vue";
import ListaOperaciones from "@/Aplicaciones/CCD/Areas/CCD/Componentes/ListaOperaciones.vue";
import FadeLoader from "vue-spinner/src/FadeLoader.vue";

export default defineComponent({
  name: "Lista Principal",

  components: {
    axios,
    NavegacionSuperior,
    NavegacionLateral,
    ListaOperaciones,
    FadeLoader    
  },

  data() {
    return {
      cargando: false,
      cargando2: false,
      filtrado: false,
      respuesta: {},
      operaciones: [],
      operacionesFiltradas: [],
      seleccionadoA: false,
      seleccionadoB: false,
      seleccionadoC: false,
      seleccionadoD: false,
      subrayadoA: '',
      subrayadoB: '',
      subrayadoC: '',
      subrayadoD: '',
      valorInicial: 1,
      totalBotones: 0,
      valorBoton: 0,
      totalBotonesArray: [],
      valorPaginado: 0,
      current: 0,
      steps: 25,
      estaFiltrado: false,
      isLastPage: false      
    }
  },

  async created() {
    this.validarSesion()
  },

  mounted() {
    if (this.$route.params.estatus == '1') {
      this.seleccionadoA = false
      this.seleccionadoB = true
      this.seleccionadoC = false
      this.seleccionadoD = false
      this.subrayadoA = ''
      this.subrayadoB = 'text-decoration-underline'
      this.subrayadoC = ''
      this.subrayadoD = ''
    }
    if (this.$route.params.estatus == '2') {
      this.seleccionadoA = false
      this.seleccionadoB = false
      this.seleccionadoC = true
      this.seleccionadoD = false
      this.subrayadoA = ''
      this.subrayadoB = ''
      this.subrayadoC = 'text-decoration-underline'
      this.subrayadoD = ''
    }
    if (this.$route.params.estatus == '3') {
      this.seleccionadoA = false
      this.seleccionadoB = false
      this.seleccionadoC = false
      this.seleccionadoD = true
      this.subrayadoA = ''
      this.subrayadoB = ''
      this.subrayadoC = ''
      this.subrayadoD = 'text-decoration-underline'
    }      
  },

  watch: {
    $route() {
      this.obtenerOperaciones()      
    }     
  },

  computed: {
    getItems(){     
     if(this.current ==1 ){
      this.current = 0; 
      const endArray = 25;     
      return this.operaciones.slice(this.current, endArray);
     }else{
      const endArray = this.current + this.steps;
      return this.operaciones.slice(this.current, endArray);      
     }          
    },     
  },
  
  methods: {
    esFiltrado(value){       
        this.estaFiltrado = value;
    },
    obtenerMensajeError(error) {
      if(String(error).includes("401")) {
        this.$router.push({ name: 'Login' })
        return 'Error de autenticación, por favor ingresa tus credenciales'
      }
      if(error == 'Error: Network Error') {
        return 'Error de conexión'
      }
      return error
    },   
    async validarSesion() {
      await this.axios
        .post("Usuario/ValidarSesion")
        .then((response) => {
          this.respuesta = response.data
          if (this.respuesta.estatusRespuesta == this.estatusRespuesta.OK) {
            this.cargando = true;
            this.obtenerOperaciones();
          }
          else {this.notificar({Estatus: this.estatusRespuesta.ERROR, Mensaje: 'Error de autenticación, por favor ingresa tus credenciales'})}
        })
        .catch((error) => {
          this.notificar({Estatus: this.estatusRespuesta.ERROR, Mensaje: this.obtenerMensajeError(error)});
        })
    },

    selectPage(index){
      this.isLastPage = index === this.getTotalPages - 1;
      this.current = index * this.steps;
    },   

    async obtenerOperaciones() {
      let estatus = this.$route.params.estatus;          
      if (estatus != undefined) {
        this.cargando2 = true
        this.axios
        .get(`Operacion?estatusOperacion=${estatus}`)
        .then((response) => {
          this.respuesta = response.data
          if (this.respuesta.estatusRespuesta == this.estatusRespuesta.OK) {
            this.operaciones = this.respuesta.resultado
            this.totalBotones = this.operaciones.length/25           
            this.operacionesFiltradas = []            
            this.valorPaginado = 25 
            this.valorBoton = 0
            this.totalBotonesArray = []
            this.operaciones.forEach(element => { 
              if(this.valorBoton < this.totalBotones){              
              this.totalBotonesArray.push(this.valorBoton)
              this.valorBoton ++;              
            }
            });            
            this.operaciones.forEach(element => {                
                if(this.valorInicial <= this.valorPaginado){                  
                this.operacionesFiltradas.push(element);
                this.valorInicial ++;
                }                
            });
           this.current = 1;            
          }
          else {this.notificar({Estatus: this.respuesta.estatusRespuesta, Mensaje: this.respuesta.mensaje})}
        })
        .catch((error) => {
          this.notificar({Estatus: this.estatusRespuesta.ERROR, Mensaje: this.obtenerMensajeError(error)});
        })
        .finally(() => (
          this.cargando = false,
          this.cargando2 = false
          )
        );
      }
    }
  },
})
</script>

<style scoped>

.paginator__btn {
		border: none;
		margin-right: 1px;    
    align-content: center;
		padding: 5px 12px;
		cursor: pointer;
		background-color: #ffff;
    border: 1px solid #f78113;
		color: #f78113;
		outline: none;
    min-height: 40px;
    min-width: 40px;
	}
  .paginator__btn:first-of-type{
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
  }
  .paginator__btn:last-of-type{
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
  }
  .paginator_buttons{
    align-content: center;
  }
 /*  .paginator__buttons .paginator__btn:first-of-type {
		border-top-left-radius: 6px;
		border-bottom-left-radius: 6px;
	}
	.paginator__buttons .paginator__btn:last-of-type {
		border-top-right-radius: 6px;
		border-bottom-right-radius: 6px;
	} */
  
	.paginator__btn:hover {
		background-color: #f78113;
    color: white;
	}

	.paginator__btn:active, .paginator__btn:focus {
		background-color: #f78113;
    color: white;
	}

</style>

